// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 0.5C10.8095 0.5 9.75936 1.09427 9.12759 2H2.5V22H21.5V2H14.8724C14.2406 1.09427 13.1905 0.5 12 0.5ZM9 9.5C9 7.84315 10.3431 6.5 12 6.5C13.6569 6.5 15 7.84315 15 9.5C15 11.1569 13.6569 12.5 12 12.5C10.3431 12.5 9 11.1569 9 9.5ZM6 18C6 15.7909 7.79086 14 10 14H14C16.2091 14 18 15.7909 18 18V19H6V18Z"}}]};

const AssignmentUserFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'assignment-user-filled',
    ref,
    icon: element,
  },
));

AssignmentUserFilledIcon.displayName = 'AssignmentUserFilledIcon';

export default AssignmentUserFilledIcon;
